import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 15px 0;
  border-top: 1px solid #e2e5e8;
  //border-bottom: 1px solid #e2e5e8;
`
